import React, { useState } from 'react';
import { Stack, TextField, IconButton, Chip, InputLabel, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

interface SettingArrayFieldProps {
  value: string[];
  onChange: (value: string[]) => void;
  label?: string;
}

const SettingArrayField: React.FC<SettingArrayFieldProps> = ({ value, onChange, label }) => {
  const [input, setInput] = useState('');

  const safeValue: string[] = Array.isArray(value) ? value : [];

  const handleAdd = () => {
    const items: string[] = input
      .split(',')
      .map((v: string) => v.trim())
      .filter(Boolean);

    const newItems = items.filter((item: string) => !safeValue.includes(item));

    if (newItems.length > 0) {
      onChange([...safeValue, ...newItems]);

      setInput('');
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if ((e.key === ' ' || e.key === 'Enter') && input.length) {
      handleAdd();
      e.preventDefault();
    }
  };

  const handleRemove = (item: string) => {
    onChange(safeValue.filter((v: string) => v !== item));
  };

  return (
    <Stack spacing={1}>
      {label && <InputLabel sx={{ fontWeight: 500 }}>{label}</InputLabel>}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <TextField
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleInputKeyDown}
          size="small"
          placeholder="Type value and press space, Enter, or paste comma-separated list"
          sx={{ flex: 1 }}
        />
        <IconButton color="primary" onClick={handleAdd} disabled={!input?.trim()}>
          <AddIcon />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
        {safeValue.filter(Boolean).map((item: string, idx: number) => (
          <Chip
            key={item + idx}
            label={item}
            onDelete={() => handleRemove(item)}
            deleteIcon={<CloseIcon />}
            sx={{ fontSize: 14 }}
          />
        ))}
      </Box>
    </Stack>
  );
};

export default SettingArrayField;
